import React, { useEffect } from "react";
import detector from "detector";

import routing from "../../routing";
import { battleOfTheHunsId } from "../../../common/parameters";
import getPlan from "../../store/plan/actions/getPlan";

import Seo from "../../../common/helpers/seo";

import { StyledBattle } from "./styles";
import { useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import defaultSeo from "./defaultSeo";

const BattleOfTheHuns = () => {
    const dispatch = useDispatch();
    useEffect(() => {
        if (detector.os.name !== "ios") {
            document.body.style.overflowY = "hidden";
        }
        setTimeout(() => {
            dispatch(getPlan("/" + routing.publicPlan + "/" + battleOfTheHunsId, () => {}));
        }, 3000);
        return () => {
            document.body.style.overflowY = "";
        }
    }, []);
    const { locale } = useIntl()
    const lang = locale === "hu" ? "hu" : "en";
    return (
        <StyledBattle>
            <Seo
                title={defaultSeo[lang].title}
                description={defaultSeo[lang].description}
                image={defaultSeo.image}
            />
            <iframe src={`/battle-of-the-huns/index_${lang}.html`} title={defaultSeo[lang].title}></iframe>
        </StyledBattle>
    );
}

export default BattleOfTheHuns;

